export default "__VITE_ASSET__CIVD3RGy__"